// shared-components/lm-action-cell/lm-action-cell.component.ts
// Angular AG Grid cell renderer for Edit + Delete action columns in LM grids.
// Uses [lmTooltip] directive for consistent tooltip styling across the module.

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { LmTooltipDirective } from '../tooltip/tooltip.directive';

@Component({
  selector: 'ers-lm-action-cell',
  standalone: true,
  imports: [CommonModule, LmTooltipDirective],
  template: `
    <div class="lm-action-container">
      <button class="lm-action-btn"
              [lmTooltip]="'Edit'"
              tooltipPosition="top"
              data-action="edit"
              [attr.data-id]="rowId">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M3 21V16.75L16.2 3.575C16.4 3.39167 16.621 3.25 16.863 3.15C17.105 3.05 17.359 3 17.625 3
                   C17.891 3 18.1493 3.05 18.4 3.15C18.6507 3.25 18.8673 3.4 19.05 3.6L20.425 5
                   C20.625 5.18333 20.771 5.4 20.863 5.65C20.955 5.9 21.0007 6.15 21 6.4
                   C21 6.66667 20.9543 6.921 20.863 7.163C20.7717 7.405 20.6257 7.62567 20.425 7.825
                   L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z" fill="#18669F"/>
        </svg>
      </button>
      <button class="lm-action-btn"
              [lmTooltip]="'Delete'"
              tooltipPosition="top"
              data-action="delete"
              [attr.data-id]="rowId">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M7.616 20.0005C7.15533 20.0005 6.771 19.8465 6.463 19.5385C6.155 19.2305 6.00067
                   18.8458 6 18.3845V6.00047H5V5.00047H9V4.23047H15V5.00047H19V6.00047H18V18.3855
                   C18 18.8455 17.846 19.2298 17.538 19.5385C17.23 19.8471 16.8453 20.0011 16.384
                   20.0005H7.616ZM9.808 17.0005H10.808V8.00047H9.808V17.0005ZM13.192 17.0005H14.192
                   V8.00047H13.192V17.0005Z" fill="#D01A2C"/>
        </svg>
      </button>
    </div>
  `,
  styles: [`
    .lm-action-container {
      display: flex;
      align-items: center;
      gap: 10px;
      height: 100%;
    }
    .lm-action-btn {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.15s;
    }
    .lm-action-btn:hover { background: rgba(0,0,0,0.06); }
  `],
})
export class LmActionCellComponent implements ICellRendererAngularComp {
  rowId: string | number = '';

  agInit(params: ICellRendererParams): void {
    this.rowId = params.data?.id ?? '';
  }

  refresh(params: ICellRendererParams): boolean {
    this.rowId = params.data?.id ?? '';
    return true;
  }
}
